export const getExtraDOMAttributes = (attributes) => {
  const { jumpTo, sectionSelector, scrollBehaviour, scrollDuration } =
    attributes;
  return {
    ["data-jump-to"]: jumpTo ?? "top",
    ...(jumpTo === "section"
      ? { ["data-jump-section"]: sectionSelector ?? "#" }
      : {}),
    ["data-scroll-behaviour"]: scrollBehaviour ?? "smooth",
    ...(scrollBehaviour === "custom"
      ? { ["data-scroll-duration"]: scrollDuration ?? 3000 }
      : {}),
  };
};
